import { store } from "../../../store/store";
import { isObjectNotEmpty } from "../CommonUtils";
import { updateUserDetails } from "../redux/commonRedux";
import { doMultipart as OMSMultipartAPI } from "../api/OMSAPI";
import { OMSOrderDataSubscription } from "../subject-behaviour/CommonRxjsService";
import { clearCartData, clearRepeatOrderData } from "./OMSCartUtils";
import { MoengageEvents, trackMoengageEvents } from "../webapp-services/MoengageUtils";

import { ScreenRoute } from "../../constants/ScreenRouteConstant";

import Compressor from 'compressorjs';

import * as AlertService from "../AlertLoaderService";

export default async function PlaceOMSOrder(props,
    { orderData, addressData = {}, userUpdatedData = {},
        setToastModalData = null }) {
    AlertService.loaderModal.setLoader(true);

    let imageList = orderData['imageList']
    delete orderData['imageList']
    const formData: FormData = new FormData();
    formData.append('orderData', JSON.stringify(orderData))

    if (isObjectNotEmpty(addressData))
        formData.append('addressData', JSON.stringify(addressData))

    if (isObjectNotEmpty(userUpdatedData)) {
        const reduxState: any = store.getState();
        let userDetails = reduxState.userDetails
        if (isObjectNotEmpty(reduxState.userDetails)) {
            userUpdatedData = {
                ...userUpdatedData,
                id: userDetails['id'],
                userId: userDetails['id']
            }
            userDetails['isNameCaptured'] = true
            userDetails['name'] = userUpdatedData['name']
            updateUserDetails(userDetails)
        }
        formData.append('userUpdatedData', JSON.stringify(userUpdatedData))
    }

    if (imageList && imageList.length) {
        var tracker = [];
        imageList.forEach(async (imageData) => {
            let blob = await (await fetch(imageData['imageURL']).
                catch(() => { return new Response() })).blob().catch(() => { return '' });
            // let c = await new Compressor(blob, { quality: 0.6 })
            // formData.append('file', c['file'])
            if (blob)
                formData.append('file', blob)
            tracker.push(1);
        })
        while (true) {
            await new Promise(r => setTimeout(r, 500));
            if (tracker.length == imageList.length) break
        }
    }

    OMSMultipartAPI('order/web/add', formData).then(
        (response: any) => {
            if (response == null || response.errMsg) {
                AlertService.loaderModal.setLoader(false);
                if (response.errMsg && setToastModalData) {
                    setToastModalData({
                        showToast: true,
                        text: response.errMsg
                    })
                }
            } else {
                global.navigateFrom = '';
                trackMoengageEvents(MoengageEvents.oms_order_placed);
                clearCartData()
                clearRepeatOrderData()
                OMSOrderDataSubscription.clearOmsOrderData();
                // UserSavedAddressSubscription.setSavedAddress({})
                props.navigation.navigate(ScreenRoute.order_successful,
                    { orderId: response.orderList[0].oid })
                AlertService.loaderModal.setLoader(false);
            }
        }, (error: any) => {
            AlertService.loaderModal.setLoader(false);
            console.log('error: ', error)
        })
}